// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlertOutlinedSvg from "@ant-design/icons-svg/es/asn/AlertOutlined";
import AntdIcon from '../components/AntdIcon';

var AlertOutlined = function AlertOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlertOutlinedSvg
  }));
};

AlertOutlined.displayName = 'AlertOutlined';
export default /*#__PURE__*/React.forwardRef(AlertOutlined);